import { useEffect, useState } from 'react';
import { api } from '../api';
import { Partner } from '../data/Partner';
import { useLiff } from '../units/liff';
import { useLoginState } from './useLoginState';
import { ResPartnerRequestData } from '../api/resPartner';
import { LiffState } from '../units/liff/components';

export function usePartner() {
    const [partner, setPartner] = useState<Partner | null>(null);
    const [partnerLineUid, setPartnerLineUid] = useState<string | null>(null);
    const [isLoading, setLoading] = useState(true);
    const { profile, isLoadLiff, state: liffState } = useLiff();
    const { loginState } = useLoginState();

    useEffect(() => {
        if (isLoadLiff()) {
            if (liffState === LiffState.ProfileLoaded && profile) {
                loadPartner({
                    login: '',
                    line_uid: profile.userId,
                });
            }
        } else if (loginState.login || loginState.line_uid) {
            loadPartner(loginState);
        } else {
            setPartner(null);
            setLoading(false);
        }
    }, [JSON.stringify(loginState), liffState]);

    function loadPartner(data: ResPartnerRequestData) {
        setLoading(true);
        api.resPartner({
            line_uid: data.line_uid,
            login: data.login,
        }).then((resData) => {
            setPartnerLineUid(data.line_uid);
            setPartner(resData);
            setLoading(false);
        }).catch(() => {
            setPartner(null);
            setLoading(false);
        });
    }

    return {
        partner,
        partnerLineUid,
        isLoading,
    };
}
